import { useTranslation } from 'react-i18next';
import { replaceAllMerchantLabels } from 'Utils';

// use this if the API data has 'Merchants' or 'MID' in the string and you want to
// replace that with what's in the config
const useReplaceMerchant = (thisString: string) => {
    const { t } = useTranslation();
    const newString = replaceAllMerchantLabels(thisString, t);

    return newString;
};

export default useReplaceMerchant;
